enum UserType {
    Undefined = 0,
    Commbox = 1,
    Integrator = 2,
    FinalCustomer = 3
}

export default UserType;